/* eslint-disable react/display-name */
import { useEffect,useState } from 'react';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

//import { useNavigate } from 'react-router-dom';
import DialogVisualiserDocument from '../../../Components/Dialogs/DialogVisualiserDocument';
//import { useNavigate } from 'react-router-dom';
import { MaterialTableComponent } from '../../../Components/shared/ReusableSmallComponents';
import { statutDocAdministratifs, typeDocument } from '../../../data/Interfaces';
//import axios from '../../../Api/axios';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import useUtilities from '../../../hooks/useUtilities';
import { formatDateJJMMYYYY } from '../../../Utils/dateFormatter';
import { addTiret, getNomPrenomClearFromPersoData, searchLabelInEnumByValue } from '../../../Utils/utils';
const DocumentAdministratifsClient = () => {

    const { i18n } = useTranslation();
    const docAdministratifsColumns = [
        {
            field: 'titre',
            title: i18n.t('Type de document'),
            render:  rowData =>
                i18n.t(searchLabelInEnumByValue(typeDocument,rowData?.titre))
            //headerStyle:{width:'84px'},
            //cellStyle:{
            //    border:'1px solid #C3C9F1'
            //}
        },
        {
            field: 'noDoc',
            title: i18n.t('N° du doc'),
            render: rowData =>
                addTiret(rowData?.noDoc)

        },
        {
            field: 'statut',
            title: i18n.t('Statut'),
            render: rowData => (
                i18n.t(searchLabelInEnumByValue(statutDocAdministratifs,rowData?.statut))
            )
            //    <>
            //        <FormControl>
            //            <InputLabel>Statut</InputLabel>
            //            <Select
            //                labelId="Statut"
            //                id="status-select"
            //                //variant="filled"
            //                label="Statut"
            //                name="Statut"
            //                autoComplete="off"
            //                //input={<OutlinedInput label="Statut" value={rowData?.statut} />}
            //                //MenuProps={MenuPropsSelectComponent}
            //                style={{width:'120px'}}
            //                value={rowData?.statut}
            //                onChange={(e) => {
            //                    console.log('statut rowselected',e.target.value);
            //                    if(e.target.value=='valide'){
            //                        axiosPrivate.post('docAdministratif/changeDocStatus', { docId:rowData?.id,statut:e.target.value })
            //                            .then(() => { getDocumentAdministratifs(); })
            //                            .catch(error => console.log(error));
            //                    }
            //                    else{
            //                        setIdSelectedDoc(rowData?.id);
            //                        console.log('selected',idSelectedDoc);
            //                        setOpenDialogRejet(true);
            //                    }

            //                }}

            //            >
            //                <MenuItem value='rejete' >Rejeté</MenuItem>
            //                <MenuItem value='valide' >Validé</MenuItem>
            //                <MenuItem
            //                    value='encours'
            //                    hidden
            //                >Encours</MenuItem>
            //                {/*<MenuItem value='valide' >Validé</MenuItem>*/}
            //            </Select>
            //        </FormControl>
            //    </>
            //)

        },
        {
            field: 'clientId',
            title: i18n.t('Réf.Client'),

        },
        {
            field: 'nomClient',
            title: i18n.t('Nom du Client'),

        },
        {
            field: 'dateTelechargement',
            title: i18n.t('Date de téléchargement'),
            render: rowData =>
                formatDateJJMMYYYY(rowData?.dateTelechargement)

            //valueGetter: (params: GridValueGetterParams) =>
            //  `${params.row.firstName || ''} ${params.row.lastName || ''}`,
        },
        {
            field: 'telechargerPar',
            title: i18n.t('Téléchargé par'),

            //valueGetter: (params: GridValueGetterParams) =>
            //  `${params.row.firstName || ''} ${params.row.lastName || ''}`,
        },
        {
            field: 'dateValidite',
            title: i18n.t('Date de validité'),
            render: rowData =>
                formatDateJJMMYYYY(rowData?.dateValidite)

            //valueGetter: (params: GridValueGetterParams) =>
            //  `${params.row.firstName || ''} ${params.row.lastName || ''}`,
        },
    ];
    //valueGetter: (params: GridValueGetterParams) =>
    //  `${params.row.firstName || ''} ${params.row.lastName || ''}`,
    //<Button
    //    variant='text'
    //    onClick={()=> {
    //        console.log(rowData);
    //        setSelectedMission(rowData);
    //        setOpenPropCommerciale(true);}}
    //>
    //    {rowData?.refPropCommerciale}
    //</Button>
    const [openDialogVisualiserDoc, setOpenDialogVisualiserDoc] = useState(false);
    const [documentAdministratifs, setDocumentAdministratifs] = useState();
    const axiosPrivate = useAxiosPrivate();
    const { setBackdropOpen } = useUtilities();
    const [arraymission, setArrayDocAdministratifs] = useState([]);
    const [rowselected,setRowSelected]=useState();

    useEffect(() => {
        getDocumentAdministratifs();
    },[]);

    useEffect(() => {
        if(documentAdministratifs){
            let Array1=[];
            console.log('test',documentAdministratifs);
            documentAdministratifs?.forEach(element => {
                //element?.docsAdministratifs?.forEach(doc => {
                Array1.push({
                    'id': element?._id,
                    'titre': element?.titre,
                    //'dateEmission':formatDateJJMMYYYY(element?.createdAt),
                    'noDoc':element?.noDoc,
                    'url':element?.url,
                    'clientId':element?.companyDataId?.clientId,
                    'nomClient':element?.companyDataId?.profileEntreprise?.nom,
                    'dateTelechargement':element?.createdAt,
                    'telechargerPar':getNomPrenomClearFromPersoData(element?.collaboratorId?.persoData),
                    'dateValidite':element?.dateValidite,
                    'statut':element?.statut,
                    ...element,
                });
            });
            //});

            setArrayDocAdministratifs(Array1.reverse());

            console.log(Array1,arraymission);
        }
    },[documentAdministratifs]);

    const getDocumentAdministratifs = async () => {
        setBackdropOpen(true);
        try {
            console.log('HELLO FROM the get doc adminitratifs a valider Client useEffect');
            const response = await axiosPrivate.get('/docAdministratif/getClientsDocsAdministratAValider', {
                // signal: controller.signal
            });
            console.log(response.data);
            setDocumentAdministratifs(response.data);
        } catch (error) {
            console.log(error);
        }
        setBackdropOpen(false);
    };
    const [selectedRow, setSelectedRow] = React.useState(null);
    return (
        <>
            <div className='frame9TableMissionBDCAdmin'>
                <MaterialTableComponent
                    title={i18n.t('Documents administratifs à valider')}
                    columns={docAdministratifsColumns}
                    data={arraymission}
                    onRowClick={(event, rowData) => {
                        setRowSelected(rowData);
                        setSelectedRow(rowData?.tableData.id);
                        setOpenDialogVisualiserDoc(true);
                    }}
                    // search={false}
                    selectedRow={selectedRow}
                />

                {/*<div>
                    <ThemeProvider theme={defaultMaterialTheme}>
                        <MaterialTable
                            icons={tableIcons}

                            options={materialTableOptionsWithoutSearchAndSelection}

                        />
                    </ThemeProvider>
                </div>*/}
            </div>
            <DialogVisualiserDocument
                handleClose={() => {
                    setOpenDialogVisualiserDoc(false);
                }}
                getDocumentAdministratifs={
                    async ()=>{
                        setBackdropOpen(true);
                        try {
                            console.log('HELLO FROM the get doc adminitratifs a valider Client useEffect');
                            const response = await axiosPrivate.get('/docAdministratif/getClientsDocsAdministratAValider', {
                                // signal: controller.signal
                            });
                            console.log(response.data);
                            setDocumentAdministratifs(response.data);
                        } catch (error) {
                            console.log(error);
                        }
                        setBackdropOpen(false);
                    }
                }
                document={rowselected}
                open={openDialogVisualiserDoc}
            />
        </>
    );
};

export default DocumentAdministratifsClient;